import React from "react";
import PropTypes from "prop-types";
import makeStyles from "@mui/styles/makeStyles";

import TextField from "../components/form/TextField";
import Select from "../components/form/Select";
import { Form, Field } from "react-final-form";
import Button from "@mui/material/Button";
import { MenuItem, FormControl } from "@mui/material";
import {
  ALL,
  ACTIVE,
  HIDDEN,
  mapToDisplay as mapStatusToDisplay,
} from "../DriverStatus";

const useStyles = makeStyles((theme) => ({
  form: {
    display: "flex",
  },
  formControl: {
    minWidth: 120,
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  applyButton: {
    height: "56px",
    marginRight: theme.spacing(3),
    // display: "none",
  },
}));

const DriverFilterForm = ({ initialFormValues, apply, className }) => {
  const classes = useStyles();

  const status = [
    { name: mapStatusToDisplay(ACTIVE), id: ACTIVE },
    { name: mapStatusToDisplay(HIDDEN), id: HIDDEN },
  ];

  const statusOptions = [
    <MenuItem key={ALL} value={ALL}>
      All
    </MenuItem>,
    ...status.map((status) => (
      <MenuItem key={status.id} value={status.id}>
        {status.name}
      </MenuItem>
    )),
  ];

  const handleApplyFilters = (form) => {
    apply(form);
  };

  return (
    <div className={className}>
      <Form
        onSubmit={handleApplyFilters}
        initialValues={initialFormValues}
        render={({ handleSubmit, dirty, form }) => (
          <form onSubmit={handleSubmit} className={classes.form}>
            <FormControl className={classes.formControl} fullWidth>
              <Field
                component={TextField}
                name="name"
                autoComplete="off"
                label="Name"
                type="search"
              />
            </FormControl>
            <FormControl className={classes.formControl}>
              <Field
                component={Select}
                name="status"
                autoComplete="off"
                label="Status"
                children={statusOptions}
              />
            </FormControl>
            <Button
              type="submit"
              color="primary"
              variant="outlined"
              className={classes.applyButton}
            >
              Apply
            </Button>
          </form>
        )}
      />
    </div>
  );
};

DriverFilterForm.propTypes = {
  initialFormValues: PropTypes.object,
  apply: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default DriverFilterForm;
